import { Empty } from "antd";
import {GlobeIcon} from "src/assets/Icons";
import { useTranslation } from "react-i18next";

export default function EmptyFlights(){
    const { t } = useTranslation();
    return (
      <div className="flex items-center justify-center px-6 py-16 md:p-30">
        <Empty
          image={<GlobeIcon className="text-primary-60" />}
          description={
            <div className="mx-auto max-w-full">
              <div className="text-primary-60 text-2xl md:font-medium">{t("Flights.listing.noFlightsFoundTitle")}</div>
              <div className="md:text-sm text-xs">{t("Flights.listing.noFlightsFoundSubtitle")}</div>
            </div>
          }
        />
      </div>
    );
}